import { newValidator, validateInclusion, validateNotBlank } from 'simple-valley'

export default function ugcUploadValidator(upload) {
  let v = newValidator(upload)
  v = validateNotBlank(v, ['fileType', 'fileName', 'fileSize'])

  const choices = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/tif',
    'image/tiff',
    'image/webp']

  v = validateInclusion(v, 'fileType', { choices, message: 'Only images are supported' })

  return v
}
